module.exports = __webpack_public_path__ + "img/nothing.0f3d779c.png";